export default "__VITE_ASSET__CRoq6WNf__"